// The availability filter layers optional deductions on top of the Simplicate
// baseline (capacity - booked hours). Each inclusion can be toggled independently:
// - presourcing: also subtract active project assignments
// - voorstellen: also subtract PL-proposed allocations
export const AVAILABILITY_INCLUSION_OPTIONS = [
  { value: 'presourcing', label: 'Pre-sourcing' },
  { value: 'voorstellen', label: 'Voorstellen' }
]

export const DEFAULT_AVAILABILITY_MODE = 'presourcing'

// Empty selection (= Simplicate baseline, only booked hours).
export const AVAILABILITY_BASELINE_LABEL = 'Simplicate'

// Map the selected inclusions to the backend availability_mode enum value.
export function inclusionsToMode(inclusions) {
  const hasPresourcing = inclusions.includes('presourcing')
  const hasVoorstellen = inclusions.includes('voorstellen')
  if (hasPresourcing && hasVoorstellen) return 'voorgesteld'
  if (hasPresourcing) return 'presourcing'
  if (hasVoorstellen) return 'alleen_voorstellen'
  return 'definitief'
}

// Inverse: derive the selected inclusions from a backend availability_mode enum.
export function modeToInclusions(mode) {
  switch (mode) {
    case 'voorgesteld':
      return ['presourcing', 'voorstellen']
    case 'alleen_voorstellen':
      return ['voorstellen']
    case 'presourcing':
      return ['presourcing']
    default:
      return [] // definitief / unknown → Simplicate baseline
  }
}
